import React from "react";
import { getTrackByMediaTypeAndParticipant } from "../../../base/tracks";
import Avatar from "../../../base/avatar/components/Avatar";
import Video from "../../../base/media/components/Video";
import { MEDIA_TYPE } from "../../../base/media";
import { connect } from "../../../base/redux";

export const audioVideoStatus = (type, id, isGallery = "", _tracks) => {
    let val;
    if (type === "video") {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.VIDEO, id);
    } else {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.AUDIO, id);
    }

    if (isGallery === "Y") {
        return val !== undefined ? val : true;
    }

    return val !== undefined ? val.muted : true;
};

export const galleryModeClass = (userCount) => {
    const galleryClass =
        userCount === 2
            ? "flexTwo"
            : userCount === 3
            ? "flexThree"
            : userCount === 4
            ? "flexFour"
            : userCount === 5
            ? "flexFive"
            : userCount === 6
            ? "flexSix"
            : userCount === 7
            ? "flexSeven"
            : userCount === 8
            ? "flexEight"
            : userCount === 9
            ? "flexNine"
            : userCount > 9 && userCount < 13
            ? "flexGrid-TW"
            : userCount >= 13 && userCount <= 15
            ? "flexGrid-ST"
            : userCount >= 16 && userCount <= 20
            ? "flexGrid-SX-TW"
            : "";
    return galleryClass;
};

function Gridview(props) {
    const {
        _participants,
        _tracks,
        _tileViewEnabled,
        fireGroupParticipants,
        additional_moderator, 
    } = props; 
    return (
        <div
            className="galleryWrap"
            style={_participants.length > 2 ? { height: "94%" } : {}}
        >
            <div className={`galleryRow`}>
                {(_tileViewEnabled || !_tileViewEnabled) && (
                    <div
                        className={`d-flex galleryView ${
                            _participants.length >= 2 ? "flexDivide" : ""
                        } ${galleryModeClass(_participants?.length)}`}
                    >
                        {_participants.length > 0 &&
                            _participants
                                .filter((v) => v.id !== undefined)
                                .map((val) => {
                                    let trackVideoStatus = audioVideoStatus(
                                        "video",
                                        val.id,
                                        "Y",
                                        _tracks
                                    );
                                    let access = fireGroupParticipants?.[val.id]
                                        ?.owner
                                        ? "Host"
                                        : "";
                                    let videoTrack =
                                        getTrackByMediaTypeAndParticipant(
                                            _tracks,
                                            MEDIA_TYPE.VIDEO,
                                            val.id
                                        );
                                    let additionalModerator =
                                        additional_moderator &&
                                        additional_moderator.includes(val.id)
                                            ? true
                                            : false; 
                                    return (
                                        <span
                                            className={`${
                                                val.dominantSpeaker
                                                    ? "isDominant"
                                                    : ""
                                            } ${
                                                _participants.length === 1
                                                    ? "full-view"
                                                    : ""
                                            } ${
                                                !trackVideoStatus.muted
                                                    ? "video-full-view"
                                                    : ""
                                            }`}
                                        >
                                            {(access === "Host" ||
                                                additionalModerator) && (
                                                <span className="participant-active-crown">
                                                    <img
                                                        src="public/assets/images/crown-img.svg"
                                                        alt="crown"
                                                    />
                                                </span>
                                            )}
                                            {trackVideoStatus.muted ||
                                            trackVideoStatus.muted ===
                                                undefined ? (
                                                <Avatar
                                                    className={`avatar-container largeVideoTags`}
                                                    participantId={val.id}
                                                    size={100}
                                                    displayName={val.name}
                                                    url={val.avatarURL}
                                                />
                                            ) : (
                                                <Video
                                                    className={`video-input-preview-display flipVideoY largeVideoTags ${
                                                        videoTrack?.videoType ===
                                                        "desktop"
                                                            ? "object-fit-contain"
                                                            : "video-view-transform"
                                                    }`}
                                                    videoTrack={{
                                                        jitsiTrack:
                                                            trackVideoStatus.jitsiTrack,
                                                    }}
                                                />
                                            )}
                                            <h6 className="meeting-user-name">
                                                {`${val.name} ${
                                                    access === "Host" ||
                                                    additionalModerator
                                                        ? "(Host)"
                                                        : ""
                                                }`}
                                            </h6>
                                        </span>
                                    );
                                })}
                    </div>
                )}
                {props.children}
            </div>
        </div>
    );
}

const _mapStateToProps = (state) => {
    return {
        _tileViewDimensions: state["features/filmstrip"].tileViewDimensions,
        additional_moderator: state["features/nxatel"].additional_moderator, 
    };
};

export default connect(_mapStateToProps)(Gridview);
